// import PopupMessage from "components/PopupMessage";
import PopupMsgWithPagination from "components/PopupMsgWithPagination";
import { POPUP_NAMES } from "utils/constants";

// Each item in "newFacePopupContent" can have 'headerLink' and 'featureLink'. The 'featureLink' directs to the respective new feature page, while the 'headerLink' can lead to the same destination or any other location.
const popupContent = [
  {
    title: "ربات هوش مصنوعی به رایچت اضافه شد. (نسخه بتا)",
    description: (
      <>
        <p>
          این ربات با بهره گیری از پایگاه دانش شما میتواند پاسخگوی مشتریان شما
          باشد و در صورت لزوم اپراتور های شما تکمیل کننده ی مکالمه و خاتمه دهنده
          ی آن باشند.
        </p>
        <p>
          با دستیار هوشمند رایچت می توانید بسیاری از مکالمات را به هوش مصنوعی
          بسپارید و از تجربه ی کاربری آن لذت ببرید. توجه داشته باشید ربات هوش
          مصنوعی تا قبل از قبول مکالمه عهده دار مکالمه می باشد و همچنین در زمان
          فعال سازی هوش مصنوعی ، حالت انتظار غیر فعال خواهد شد.
        </p>
        <p>
          شما میتوانید در پکیج پریمیوم پلاس هوش مصنوعی را در رایچت تجربه کنید.
        </p>
      </>
    ),
  },
  {
    title: "ربات پاسخگوی رایچت",
    description: (
      <>
        <p>
          ربات پاسخگوی پشتیبانی رایچت یک راه حل نوآورانه برای ارتقای سطح
          پشتیبانی مشتریان شما است.
        </p>
        <p>
          با این ابزار، شما می‌توانید سوالات متداول را پیش‌تعریف کنید و ربات را
          برای پاسخگویی به سوالات خاص بر اساس نیاز مشتریان آماده کنید.
        </p>
        <p>
          علاوه بر این، امکان تعریف یک فلو برای پاسخگویی گام به گام به سوالات
          مشتریان وجود دارد، که به شما امکان می‌دهد پاسخ‌های دقیق و مرتبط با
          نیازهای مشخص هر مشتری را ارائه دهید.
        </p>
      </>
    ),
  },
  {
    title: "حالت انتظار",
    description: `اگر دوست داری زمان انتظار مشتریات توی وبسایتت رو براشون قابل تحمل تر
      بکنی، قابلیت انتظار رایچت میتونه کمکت کنه. به وسیله حالت انتظار
      رایچت میتونی اطلاعات کاربرانی که منتظر دریافت پاسخ از سمت پشتیبانی
      هستن رو ازشون بگیری تا سر فرصت بتونی بهشون کمک کنی.`,
  },
  {
    title: "فرم‌ها",
    description: `وقتی کاربری وارد وبسایتت میشه و میخواد که از بخش پشتیبانی استفاده
      بکنه، نیازه که اطلاعاتش رو توی فیلدهای مشخص شده وارد بکنه تا شما
      بتونید دسترسی بهتری به کاربرتون داشته باشید. با استفاده از این فیچر
      شما میتونید فرم های مختلف رو بنابر نیاز کسب و کارتون درست کنید ودر
      اختیار مشتریاتون قرار بدین و از این طریق لید جمع کنید.`,
  },
];

const POPUP_NAME = POPUP_NAMES.NEW_FEATURES;

function UpdatedFeaturesModal() {
  return (
    // <PopupMessage
    //   popupName={POPUP_NAME}
    //   popupId="response_bot"
    //   content={popupContent}
    // />

    <PopupMsgWithPagination
      popupName={POPUP_NAME}
      popupId="AI_bot"
      popupContent={popupContent}
    />
  );
}

export default UpdatedFeaturesModal;
